var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ maxWidth: '350px' })},[_c('KImg',{attrs:{"src":require('../common/hummingbird-small-cc-by-sa-4.jpg'),"altText":"A sitting hummingbird","aspectRatio":"4:3"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }